import { ExpenseType } from '@crimsontide/core/client/interfaces';
import DotNetObject = DotNet.DotNetObject;

export const ExpenseTypeService = (() => {
  let dotNetObj: DotNetObject;
  let cachedExpenseTypes: ExpenseType[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getExpenseTypes = async (useCache: boolean = true): Promise<ExpenseType[]> => {
    if (useCache && cachedExpenseTypes != null)
      return cachedExpenseTypes;

    if (dotNetObj) {
      cachedExpenseTypes = await dotNetObj.invokeMethodAsync<ExpenseType[]>('GetAsync');
      return cachedExpenseTypes;
    } else {
      throw 'Expense Type DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getExpenseTypes,
  };
})();
